import { useAppDispatch, useAppSelector } from 'coreOld/hooks';
import { useNotification } from 'coreOld/hooks/useNotification';
import { setSelectedRow } from 'coreOld/slices';
import { IRequest } from 'support/types';

import RequestDetailsView from './RequestDetailsView';

const RequestDetails = () => {
  const dispatch = useAppDispatch();

  const { selectedRow } = useAppSelector((state) => state.table);
  const { clearNotification } = useNotification();

  const onClosePanel = () => {
    clearNotification();
    dispatch(setSelectedRow(null));
  };

  return (
    <RequestDetailsView selectedRequest={selectedRow as IRequest} onClosePanel={onClosePanel} />
  );
};

export default RequestDetails;
